module.exports = __webpack_public_path__ + "img/bw1.e9ad874a.png";